import { render, staticRenderFns } from "./AddUpdateFoodPack.vue?vue&type=template&id=45da6d5c"
import script from "./AddUpdateFoodPack.vue?vue&type=script&lang=js"
export * from "./AddUpdateFoodPack.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateFoodPack.vue?vue&type=style&index=0&id=45da6d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports